import axios from 'axios';
import { ACR_VALUES } from '@/config';
import {
  requestInterceptor,
  responseInterceptor,
  responseInterceptorDS,
} from './interceptor';
import { API, NODE_ENV, SIGNATURE_API } from '@/config';

export const api = axios.create({
  baseURL: API.BASE_URL,
  timeout: NODE_ENV === 'production' ? API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    //ECG:En config tenemos un keyvaluepair, tomo solo el value
    tenant: ACR_VALUES.split(':')[1],
  },
});

api.interceptors.request.use(
  requestInterceptor.onFulfilled,
  requestInterceptor.onRejected
);

api.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
);

export const signatureApi = axios.create({
  baseURL: SIGNATURE_API.BASE_URL,
  timeout: NODE_ENV === 'production' ? SIGNATURE_API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    tenant: 'DigitalSignatureApi',
    Authorization: `Bearer ${localStorage.getItem('accessTokenDS')}`,
  },
});

signatureApi.interceptors.response.use(
  responseInterceptorDS.onFulfilled,
  responseInterceptorDS.onRejected
);

//Add a cancellation token to the request
export const getCancellationToken = () => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  return source;
};

export const isCancel = (error) => {
  return axios.isCancel(error);
};
